import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (_ref, inject) {
  var $axios = _ref.$axios,
    store = _ref.store;
  var api = $axios.create();

  // request interceptors
  var requestInterceptor = api.interceptors.request.use(function (config) {
    var _store$state, _store$state$auth, _store$state$auth$use;
    var url = config.url,
      method = config.method,
      params = config.params,
      headers = config.headers,
      baseURL = config.baseURL;
    if (process.server && !process.env.isDev) {
      // eslint-disable-next-line
      console.log('request', JSON.stringify({
        url: url,
        method: method,
        params: params,
        headers: headers,
        baseURL: baseURL
      }));
    }
    // if (process.server) {
    //   api.interceptors.request.eject(requestInterceptor);
    // }
    var token = store === null || store === void 0 ? void 0 : (_store$state = store.state) === null || _store$state === void 0 ? void 0 : (_store$state$auth = _store$state.auth) === null || _store$state$auth === void 0 ? void 0 : (_store$state$auth$use = _store$state$auth.user) === null || _store$state$auth$use === void 0 ? void 0 : _store$state$auth$use.token;
    return _objectSpread(_objectSpread({}, config), {}, {
      params: _objectSpread({
        authenticity_token: token
      }, config.params || {}),
      url: process.client ? "/api".concat(config.url) : config.url,
      meta: {
        requestStartedAt: new Date().getTime()
      }
    });
  }, function (error) {
    if (process.server) {
      api.interceptors.request.eject(requestInterceptor);
    }
    Promise.reject(error);
  });

  // response interceptors
  var responseInterceptor = api.interceptors.response.use(function (response) {
    var status = response.status,
      statusText = response.statusText,
      headers = response.headers,
      _response$config = response.config,
      url = _response$config.url,
      method = _response$config.method,
      params = _response$config.params,
      meta = _response$config.meta;
    if (process.server && !process.env.isDev) {
      // eslint-disable-next-line
      console.log("execution time for: ".concat(url, " - ").concat(new Date().getTime() - meta.requestStartedAt, " ms"));
      // eslint-disable-next-line
      console.log('response', JSON.stringify({
        status: status,
        statusText: statusText,
        headers: headers,
        request: {
          url: url,
          method: method,
          params: params
        }
      }));
    }
    return response;
  }, function (error) {
    if (process.server) {
      api.interceptors.response.eject(responseInterceptor);
    }
    return Promise.reject(error);
  });
  inject('api', api);
});